import { Component, inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IFormDropDownItem } from "src/app/common-components/form-controls/form-dropdown/dropdown.component";
import { CstBelegartService } from "src/app/services/wawi/belegart.service";
import { AnlageWartungsHistoryEntryType } from "src/app/web-api/web-api";
import { WartungsHistoryExtendedFilterModel } from "./wartungshistory-extended-filter.model";
import {
  CstFormBuilder,
  CstFormGroup,
} from "src/app/_uncategorised_models_services/cst-form-group";

@Component({
    selector: "wartungshistory-filter-component",
    templateUrl: "./wartungshistory-extended-filter.component.html",
    styles: [""],
    standalone: false
})
export class WartungshistoryExtendedFilterComponent {
  private _belegArtService = inject(CstBelegartService);
  dialogRef = inject<MatDialogRef<WartungshistoryExtendedFilterComponent>>(MatDialogRef);
  data = inject<WartungsHistoryExtendedFilterModel>(MAT_DIALOG_DATA);

  public form: CstFormGroup<WartungsHistoryExtendedFilterModel>;

  public receiptTypeFilterAvailable = [];
  public entryTypeFiltersAvailable: Array<IFormDropDownItem> = [
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_None:All Entry Types`,
      value: AnlageWartungsHistoryEntryType.None,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Task:Tasks`,
      value: AnlageWartungsHistoryEntryType.Task,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Receipt:Receipts`,
      value: AnlageWartungsHistoryEntryType.Receipt,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Document:Documents`,
      value: AnlageWartungsHistoryEntryType.Document,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Note:Notes`,
      value: AnlageWartungsHistoryEntryType.Note,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Folder:Folder`,
      value: AnlageWartungsHistoryEntryType.Process,
    },
    {
      label: $localize`:@@AnlageWartungsHistoryEntryType_Contract:Contracts`,
      value: AnlageWartungsHistoryEntryType.Contract,
    },
  ];

  public showReceiptFilter = false;
  public showTasksFilter = false;

  constructor() {
    const data = this.data;
    const fb = inject(CstFormBuilder);

    this.form = fb.group<WartungsHistoryExtendedFilterModel>({
      receiptTypeFilter: new FormControl(data.receiptTypeFilter),
      eventFilter: new FormControl(data.eventFilter),
      tasksShowDeleted: new FormControl(data.tasksShowDeleted),
    });
    this.receiptTypeFilterAvailable = this._belegArtService.toArray().slice(1);
    this.form.valueChanges.subscribe((value) => {
      this.data = value;
      this._showSubFilters();
    });
    this._showSubFilters();
  }

  private _showSubFilters(): void {
    this.showReceiptFilter =
      this.data.eventFilter === AnlageWartungsHistoryEntryType.None ||
      this.data.eventFilter === AnlageWartungsHistoryEntryType.Receipt;
    this.showTasksFilter =
      this.data.eventFilter === AnlageWartungsHistoryEntryType.None ||
      this.data.eventFilter === AnlageWartungsHistoryEntryType.Task;
    if (this.showReceiptFilter === false) {
      this.data.receiptTypeFilter.length = 0;
      this.form.controls.receiptTypeFilter.setValue(
        this.data.receiptTypeFilter,
        { emitEvent: false }
      );
    }
    if (!this.showTasksFilter) {
      this.form.controls.tasksShowDeleted.setValue(false, { emitEvent: false });
    }
  }

  public getLabelForEventType(eventType: number): string {
    for (const e of this.entryTypeFiltersAvailable) {
      if (e.value === eventType) return e.label;
    }
    return "";
  }

  public getLabelForReceiptType(receiptType: number): string {
    for (const e of this.receiptTypeFilterAvailable) {
      if (e.value === receiptType) {
        return e.key;
      }
    }
    return "";
  }

  onReceiptTypeRemoved(receiptType: number) {
    const receiptTypes = this.form.controls.receiptTypeFilter.value as number[];
    this.removeFirst(receiptTypes, receiptType);
    this.form.controls.receiptTypeFilter.setValue(receiptTypes);
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  onNoClick(): void {
    this.dialogRef.close(null);
  }
}
